import { Grid } from '@mui/material';
import { SectionWrapper } from './DashboardShared';
import GraphCard from '../../analytics/components/GraphCard';
import '../styles/dashboard.scss';

const PinnedModuleSection = ({ moduleTitle, subtitle, entries, onUnpin, loading, analyticsFilterMenu, }) => {
  if (loading || !entries?.length) return null;

  return (
    <SectionWrapper title={moduleTitle} subtitle={subtitle}>
        <Grid container spacing={1.5} alignItems="stretch">
          {entries.map((entry) => {
            const graph = entry.graph ?? entry;
            return (
            <Grid key={entry.id ?? graph?.uuid} size={{ xs: 12 }}>
              <GraphCard
                variant="dashboard"
                graph={graph}
                pinnedEntry={entry}
                onUnpin={onUnpin}
                analyticsFilterMenu={analyticsFilterMenu}
              />
            </Grid>
            );
          })}
        </Grid>
    </SectionWrapper>
  );
};

export default PinnedModuleSection;
